import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DcRosterConfigDocument } from '../../../domain/dc-roster-config.model';

export interface DcRosterConfigFormValue {
  dcType: string;
  subType: string;
  description: string;
}

export interface DcRosterConfigDialogData {
  mode: 'create' | 'edit';
  config?: DcRosterConfigDocument;
}

@Component({
  selector: 'app-dc-roster-config-dialog',
  templateUrl: './dc-roster-config-dialog.component.html',
  styleUrls: ['./dc-roster-config-dialog.component.css']
})
export class DcRosterConfigDialogComponent {
  readonly values: DcRosterConfigFormValue;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DcRosterConfigDialogData,
    private dialogRef: MatDialogRef<
      DcRosterConfigDialogComponent,
      DcRosterConfigFormValue | null
    >
  ) {
    this.values = {
      dcType: data.config?.dcType ?? '',
      subType: data.config?.subType ?? '',
      description: data.config?.description ?? ''
    };
  }

  get allValid(): boolean {
    return (
      !!this.values.dcType?.trim() &&
      this.values.dcType.trim().length <= 50 &&
      !!this.values.subType?.trim() &&
      this.values.subType.trim().length <= 50 &&
      typeof this.values.description === 'string' &&
      this.values.description.trim().length <= 200
    );
  }

  close(): void {
    this.dialogRef.close(null);
  }

  submit(): void {
    if (!this.allValid) {
      return;
    }
    this.dialogRef.close({
      dcType: this.values.dcType.trim(),
      subType: this.values.subType.trim(),
      description: this.values.description.trim()
    });
  }
}
